var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "78px",
    viewBox: "0 0 93 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.375,46.5 C61.075517,46.5 69.75,55.174483 69.75,65.875 L69.75,65.875 L69.75,73.625 C69.75,75.7651034 68.0151034,77.5 65.875,77.5 C63.7348966,77.5 62,75.7651034 62,73.625 L62,73.625 L62,65.875 C62,59.4546898 56.7953102,54.25 50.375,54.25 L50.375,54.25 L19.375,54.25 C12.9546898,54.25 7.75,59.4546898 7.75,65.875 L7.75,65.875 L7.75,73.625 C7.75,75.7651034 6.01510341,77.5 3.875,77.5 C1.73489659,77.5 0,75.7651034 0,73.625 L0,73.625 L0,65.875 C0,55.174483 8.67448297,46.5 19.375,46.5 L19.375,46.5 Z M73.7480471,49.9100011 C74.2830724,47.8378547 76.3966026,46.5917718 78.4687489,47.1267971 C87.0179618,49.3341917 92.9934129,57.0425237 93,65.875 L93,65.875 L93,73.625 C93,75.7651034 91.2651034,77.5 89.125,77.5 C86.9848966,77.5 85.25,75.7651034 85.25,73.625 L85.25,73.625 L85.2500011,65.8778904 C85.2460494,60.5801388 81.6607788,55.9551397 76.5312511,54.6307029 C74.4591047,54.0956776 73.2130218,51.9821474 73.7480471,49.9100011 Z M34.875,0 C45.575517,0 54.25,8.67448297 54.25,19.375 C54.25,30.075517 45.575517,38.75 34.875,38.75 C24.174483,38.75 15.5,30.075517 15.5,19.375 C15.5,8.67448297 24.174483,0 34.875,0 Z M58.2460937,3.41759816 C58.7769233,1.34437298 60.8879267,0.0940142446 62.9611518,0.62484375 C71.5341768,2.81988491 77.5303926,10.5448009 77.5303926,19.394375 C77.5303926,28.2439491 71.5341768,35.9688651 62.9611518,38.1639062 C60.8879267,38.6947358 58.7769233,37.444377 58.2460937,35.3711518 C57.7152642,33.2979267 58.965623,31.1869233 61.0388482,30.6560937 C66.1826631,29.3390691 69.7803926,24.7041195 69.7803926,19.394375 C69.7803926,14.0846305 66.1826631,9.44968095 61.0388482,8.13265625 C58.965623,7.60182674 57.7152642,5.49082333 58.2460937,3.41759816 Z M34.875,7.75 C28.4546898,7.75 23.25,12.9546898 23.25,19.375 C23.25,25.7953102 28.4546898,31 34.875,31 C41.2953102,31 46.5,25.7953102 46.5,19.375 C46.5,12.9546898 41.2953102,7.75 34.875,7.75 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proxy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-673.000000, -339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(349.000000, 293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(324.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#112b79",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconLight);
export default __webpack_public_path__ + "static/media/userIcon-Light.a11f423ebcd2afff858da82617ae1e65.svg";
export { ForwardRef as ReactComponent };